import React, { ReactNode, useCallback, useState } from 'react';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import useSnackBar from 'hooks/useSnackBar';
import useCustomMutation, { HandleReturn } from 'hooks/useCustomMutation';

import ProposalServices from 'services/proposalServices';

import * as S from './styles';

interface Props {
  children: ReactNode;
  dealerId: number;
  isOpen: boolean;
  onClose: () => void;
  proposalId: number;
  dontShowMessageToBlockPopup: boolean;
}

function useUpdateProposalSummary(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'updateProposalSummary',
    request: ProposalServices.updateProposalSummary,
    handleReturn,
  });
}

export function ConfirmActionDialog({
  children,
  dealerId,
  isOpen,
  onClose,
  proposalId,
  dontShowMessageToBlockPopup,
}: Props) {
  const [confirmationChoice, setConfirmationChoice] = useState<boolean>(false);

  const { error, success } = useSnackBar();

  const {
    mutate: mutateConfirmationChoice,
    isLoading: loadingConfirmationChoice,
  } = useUpdateProposalSummary({
    onError: () => {
      error('Falha ao atualizar o resumo do Lead!');
      onClose();
    },
    onSuccess: () => {
      success('Dados atualizados com sucesso!');
      onClose();
    },
  });

  const handleConfirmationChoice = useCallback(() => {
    if (!dealerId || !proposalId || dontShowMessageToBlockPopup)
      return onClose();

    return mutateConfirmationChoice({
      dealerId,
      proposalId,
      ignoreSummary: confirmationChoice,
    });
  }, [confirmationChoice]);

  return (
    <S.Dialog open={isOpen} onClose={(_, reason) => !reason && onClose()}>
      <DialogTitle>Resumo sobre este Lead</DialogTitle>
      <DialogContent>
        <S.ScrollContent>{children}</S.ScrollContent>
      </DialogContent>
      <DialogActions>
        <S.Content>
          {!dontShowMessageToBlockPopup && (
            <S.CheckboxItem
              label="Confirmo que li as informações relacionadas a este Lead e sobre seu histórico e potencial."
              control={
                <S.Checkbox
                  color="primary"
                  checked={confirmationChoice}
                  disabled={loadingConfirmationChoice}
                  onChange={({ target }) =>
                    setConfirmationChoice(target.checked)
                  }
                />
              }
            />
          )}
          <S.ConfirmButtonBox>
            <S.ConfirmButton
              color="primary"
              variant="contained"
              onClick={handleConfirmationChoice}
              disabled={
                confirmationChoice
                  ? !confirmationChoice
                  : !dontShowMessageToBlockPopup
              }
              disableElevation
            >
              {loadingConfirmationChoice && <S.LoadingButtonInfo />}
              {!loadingConfirmationChoice && 'Fechar'}
            </S.ConfirmButton>
          </S.ConfirmButtonBox>
        </S.Content>
      </DialogActions>
    </S.Dialog>
  );
}
